import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { useI18n } from "../lib/i18n";

export const DataTable = ({ cols, rows, testId, onRowClick, empty }) => {
  const { t } = useI18n();
  return (
    <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm" data-testid={testId}>
      <table className="w-full min-w-[640px] text-sm">
        <thead className="bg-slate-50">
          <tr>{cols.map((c) => <th key={c.key} className="whitespace-nowrap px-4 py-3 text-start text-xs font-semibold uppercase tracking-wider text-slate-500">{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={cols.length} className="px-4 py-10 text-center text-slate-500">{empty || t("noData")}</td></tr>}
          {rows.map((r, i) => (
            <tr key={r.id || i} data-testid={`${testId}-row-${r.id || i}`} onClick={onRowClick ? () => onRowClick(r) : undefined}
              className={`border-t border-slate-100 transition-colors ${onRowClick ? "cursor-pointer hover:bg-sky-50/50" : ""}`}>
              {cols.map((c) => <td key={c.key} className="px-4 py-3 align-top text-slate-700">{c.render ? c.render(r) : r[c.key]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const FilterSelect = ({ value, onChange, options, placeholder, testId, allowAll = true }) => {
  const { t, tv } = useI18n();
  return (
    <Select value={value || "__all"} onValueChange={(v) => onChange(v === "__all" ? "" : v)}>
      <SelectTrigger data-testid={testId} className="h-10 w-full rounded-xl sm:w-48"><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {allowAll && <SelectItem value="__all">{placeholder ? `${placeholder}: ${t("all")}` : t("all")}</SelectItem>}
        {options.map((o) => (typeof o === "object"
          ? <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
          : <SelectItem key={o} value={o}>{tv(o)}</SelectItem>))}
      </SelectContent>
    </Select>
  );
};

export const Pager = ({ page, total, limit, onPage }) => {
  const { t } = useI18n();
  const pages = Math.max(1, Math.ceil(total / limit));
  return (
    <div className="mt-4 flex items-center justify-between text-sm text-slate-600">
      <span data-testid="pager-total">{t("total")}: {total}</span>
      <div className="flex items-center gap-2">
        <button data-testid="pager-prev" disabled={page <= 1} onClick={() => onPage(page - 1)} className="rounded-lg border border-slate-200 px-3 py-1 disabled:opacity-40">{t("prev")}</button>
        <span data-testid="pager-page">{page} / {pages}</span>
        <button data-testid="pager-next" disabled={page >= pages} onClick={() => onPage(page + 1)} className="rounded-lg border border-slate-200 px-3 py-1 disabled:opacity-40">{t("next")}</button>
      </div>
    </div>
  );
};
